"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getSchemaFromTypedModel_1 = require("../getSchemaFromTypedModel");
const doValidation_1 = __importDefault(require("./doValidation"));
const getValidationErrorsObject_1 = __importDefault(require("./getValidationErrorsObject"));
const defaultOptions = {
    omitRequired: false
};
async function getValidationErrors(schema, doc, passedOptions = {}, ...args) {
    schema = (0, getSchemaFromTypedModel_1.getSchemaFromTypedModel)(schema);
    const options = { ...defaultOptions, ...passedOptions };
    const errors = [];
    const addError = function (keys, code) {
        errors.push({
            key: keys.join('.'),
            code
        });
    };
    await (0, doValidation_1.default)({
        schema,
        doc,
        currentDoc: doc,
        value: doc,
        currentSchema: { type: schema },
        addError,
        options,
        args
    });
    return (0, getValidationErrorsObject_1.default)(errors);
}
exports.default = getValidationErrors;
